import { ChakraAvatar, ChakraFlex, ChatUser } from '@equip.health/ui';

import { MEMBERS_TO_DISPLAY } from '~/lib/constants/chat.constants';
import { sortListByLastNameFromFullName } from '~/lib/utils';

import AvatarPopoverView from './AvatarPopoverView';
import MembersPopoverList from './MembersPopoverList';

const idPrefix = 'channel';
const idPostfix = 'members';
interface ChannelMembersProps {
  id: string;
  members: ChatUser[];
  paddedTop?: boolean;
  showPopoverOnHover?: boolean;
  size?: AvatarSize;
}

const ChannelMembers = ({
  id,
  members = [],
  paddedTop = true,
  showPopoverOnHover = false,
  size = 'xs',
}: ChannelMembersProps) => {
  const sortedMembers = [...members].sort(sortListByLastNameFromFullName);

  return (
    <ChakraFlex
      alignItems="baseline"
      id={`${idPrefix}-member-wrapper__${id}__${idPostfix}`}
      justifyContent="start"
      paddingTop={paddedTop ? '16px' : ''}
    >
      {(sortedMembers ?? []).map((member, index) => {
        return (
          index < MEMBERS_TO_DISPLAY && (
            <ChakraFlex
              id={`${idPrefix}-individual-member-${member.userId}__${id}__${idPostfix}`}
              key={`${idPrefix}-individual-member-${member.userId}__${id}__${idPostfix}`}
              position="relative"
            >
              <ChakraFlex
                background="transparent"
                borderRadius="50%"
                height={size === 'xs' && '28px'}
                id={`${idPrefix}-popover-container__${id}__${idPostfix}`}
                left={index === 0 ? 0 : `-${12 * index}px`}
                padding="2px"
                position="relative"
                width={size === 'xs' && '28px'}
              >
                {showPopoverOnHover ? (
                  <AvatarPopoverView
                    id={member?.userId}
                    noStyles
                    size={size}
                    user={member as ChatUser}
                  />
                ) : (
                  <ChakraAvatar
                    background="orange.50"
                    borderColor="neutral.line"
                    borderWidth="1px"
                    color="black"
                    cursor="default"
                    data-testid={`${idPrefix}-avatar__${id}__${idPostfix}`}
                    id={`${idPrefix}-avatar__${id}__${idPostfix}`}
                    name={member?.nickname}
                    showBorder
                    size="xs"
                  />
                )}
              </ChakraFlex>
            </ChakraFlex>
          )
        );
      })}
      {members?.length > MEMBERS_TO_DISPLAY && (
        <MembersPopoverList id={id} members={sortedMembers} />
      )}
    </ChakraFlex>
  );
};

export default ChannelMembers;
